var lib_core = require("lib-core");

var RectangleToolStateMachine = require("./rectangleToolStateMachine.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

var RectangleToolController = function(archLayers, dependencies, configuration) {

    this.setDefaultConfiguration({
        angle: 0,
        fill: false,
        strokeWidth: 2,
        width: 1,
        height: 1
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(RectangleToolController, AbstractToolController);
RectangleToolController.inject = AbstractToolController.inject;
RectangleToolController.StateMachineClass = RectangleToolStateMachine;

module.exports = RectangleToolController;

RectangleToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Rectangle',
        title: 'Rectangle',
        style: {
            icon: 'icon-rectangle.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
